module.exports = __webpack_public_path__ + "static/media/16UNODC9.d6dbd062.jpg";